import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-reference-details',
  templateUrl: './reference-details.component.html',
  styleUrls: ['./reference-details.component.scss']
})
export class ReferenceDetailsComponent implements OnInit {
  referenceForm!: FormGroup;
  //referenceTypes: Array<{ id: any; name: string }> = [];
  referenceTypes: any[] = [];
  allReferenceItems: any[] = [];
  filteredReferenceItems: any[] = [];
  isLoading = false;

  constructor(private fb: FormBuilder, private router: Router, public appservice: AppService) {
    this.referenceForm = this.fb.group({
      referenceType: ['']
    });
  }

  ngOnInit(): void {
    this.loadReferenceData();
    // this.referenceForm.get('referenceType')?.valueChanges.subscribe(() => {
    //   this.applyFilter();
    // });
    this.loadReference_dropdownData();
  }
loadReference_dropdownData(): void {
  this.appservice.getTable('api/Master/Reference_group').subscribe(
      (res: any) => {
        const data = res;
        if (Array.isArray(data)) {
          this.referenceTypes = data;
        } else if (data && Array.isArray(data.record)) {
          this.referenceTypes = data.record;
        } else {
          this.referenceTypes = [];
        }
        console.log('Loaded reference types:', this.referenceTypes);
     //   this.buildReferenceTypes();
        this.applyFilter();
      },
      (error) => {
        console.error('Reference values load failed', error);
        this.allReferenceItems = [];
        this.filteredReferenceItems = [];
      }
    );}
  loadReferenceData(): void {
    this.isLoading = true;
    this.appservice.getTable('api/Master/Reference_Value').subscribe(
      (res: any) => {
        const data = this.parseResponse(res);
        if (Array.isArray(data)) {
          this.allReferenceItems = data;
        } else if (data && Array.isArray(data.record)) {
          this.allReferenceItems = data.record;
        } else {
          this.allReferenceItems = [];
        }

       // this.buildReferenceTypes();
        this.applyFilter();
        this.isLoading = false;
      },
      (error) => {
        console.error('Reference values load failed', error);
        this.allReferenceItems = [];
        this.filteredReferenceItems = [];
        this.isLoading = false;
      }
    );
  }

  parseResponse(response: any): any {
    if (!response) {
      return [];
    }

    if (typeof response === 'string') {
      try {
        const cleaned = response.replace(/[^\x20-\x7E\r\n\t]/g, '');
        return JSON.parse(cleaned);
      } catch (error) {
        console.error('Failed to parse response JSON:', error);
        return [];
      }
    }

    return response;
  }

  buildReferenceTypes(): void {
    const typeMap = new Map<any, string>();
    this.referenceTypes = [];

    for (const item of this.allReferenceItems) {
      const typeId = item.REM_REFid ?? item.TypeId ?? item.ReferenceTypeId ?? item.RefGroupId ?? item.GroupId ?? item.Type;
      const typeName = item.REM_REF_Name ?? item.ReferenceType ?? item.TypeName ?? item.GroupName ?? item.Category ?? `${typeId}`;

      if (typeId !== undefined && !typeMap.has(typeId)) {
        typeMap.set(typeId, typeName);
        this.referenceTypes.push({ RG_iid: typeId, RG_Name: typeName });
      }
    }

    this.referenceTypes.sort((a, b) => `${a.RG_Name}`.localeCompare(`${b.RG_Name}`));
  }
public add:any=[];
  applyFilter(): void {
    const selectedType = this.add.RG_iid;
    if (!selectedType) {
      this.filteredReferenceItems = [...this.allReferenceItems];
      return;
    }

    this.filteredReferenceItems = this.allReferenceItems.filter((item) => {
      const typeId = item.REM_REFid ?? item.TypeId ?? item.ReferenceTypeId ?? item.RefGroupId ?? item.GroupId ?? item.Type;
      return `${typeId}` == `${selectedType}`;
    });
  }

  getCode(item: any): string {
    return item.REM_REFid ?? item.Code ?? item.ReferenceCode ?? item.CodeValue ?? '';
  }

  getDescription(item: any): string {
    return item.Description ?? item.REM_REF_Name ?? item.Value ?? item.Label ?? '';
  }

  onAddNew(): void {
    this.router.navigate(['/home/Reference-master']);
  }

  onEdit(item: any): void {
    console.log('Edit item', item);
     this.appservice.referenceEditData=item;
     this.appservice.isedit=true;
    this.router.navigate(['/home/Reference-master']);
    // TODO: wire edit navigation or open edit form here
  }

  onDelete(item: any): void {
    console.log('Delete item', item);
    if (confirm('Are you sure you want to delete this item?')) {
      // TODO: call API or delete logic here
        const id = item.id ?? item.REM_iid ?? item.REM_REFid ?? item.TypeId ?? item.ReferenceTypeId ?? item.RefGroupId ?? item.GroupId ?? item.Type;
      this.appservice.getTable('api/Master/Delete_Reference_data?Id=' + id ).subscribe(
        (res: any) => {
          alert('Item deleted successfully');
          this.loadReferenceData();
          this.loadReference_dropdownData()
        },
        (error) => {
          console.error('Delete failed', error);
          alert('Failed to delete item');
        }
      );
    }
  }
}
